var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E7ECF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 22.1681V15.7672C24.875 14.8245 24.0259 14.0603 22.9784 14.0603H22.6624C22.2796 14.0603 21.9343 13.8532 21.787 13.5351L21.088 12.0252C20.9407 11.7072 20.5954 11.5 20.2126 11.5H15.7874C15.4045 11.5 15.0593 11.7072 14.912 12.0252L14.213 13.5351C14.0657 13.8532 13.7205 14.0603 13.3376 14.0603H13.0216C11.9741 14.0603 11.125 14.8245 11.125 15.7672V22.1681C11.125 23.1108 11.9741 23.875 13.0216 23.875H22.9784C24.0259 23.875 24.875 23.1108 24.875 22.1681Z",
    stroke: "#8CA5BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 18.375C20.75 19.8938 19.5188 21.125 18 21.125C16.4812 21.125 15.25 19.8938 15.25 18.375C15.25 16.8562 16.4812 15.625 18 15.625C19.5188 15.625 20.75 16.8562 20.75 18.375Z",
    stroke: "#8CA5BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimage);
export default __webpack_public_path__ + "static/media/uploadimage.830cd3d6.svg";
export { ForwardRef as ReactComponent };